import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LandingPage.css";

const TermsConditions = () => {
  return (
    <>
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="landing-page">
        {/* Terms Content Section */}
        <section className="how-it-works" style={{ paddingTop: "120px" }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="section-title">Terms of Service</h2>
                <p className="section-subtitle">
                  Last updated: September 12, 2025
                </p>
              </div>
            </div>
            
            <div className="row">
              <div className="col-12">
                <div style={{ textAlign: "left", maxWidth: "800px", margin: "0 auto" }}>
                  
                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>1) Who We Are</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    These Terms of Service ("Terms") govern your access to and use of the website, waitlist, and 
                    related pages operated by Rite Innovations LLC (doing business as "Rite Soccer") ("Rite 
                    Soccer," "we," "us," or "our").
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>2) Acceptance</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    By accessing or using our site, you agree to these Terms and to our Privacy Policy. If you do not 
                    agree, do not use the site.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>3) Who Can Use the Site</h3>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li>The landing page and waitlist are intended for individuals <strong>16 years and older</strong>.</li>
                    <li>Individuals aged <strong>13–15</strong> may submit information <strong>only with verifiable consent from a parent or legal guardian</strong>.</li>
                    <li>The site is <strong>not directed to children under 13</strong>, and we do not knowingly collect information from them.</li>
                    <li>Where local law sets a higher minimum age for consent, we will follow that rule.</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>4) What We Provide Now</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    The current site provides information about Rite Soccer and allows you to join a waitlist or 
                    request updates. Features may change without notice.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>5) Your Responsibilities</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    You agree not to misuse the site, including (without limitation): engaging in illegal activity; 
                    harassing others; scraping or harvesting data; reverse engineering; interfering with the site's 
                    operation; or attempting to access non-public areas. Information you submit must be accurate 
                    and you must have the right to provide it.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>6) Intellectual Property</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    All content on the site (including text, logos, graphics, and design) is owned by Rite Soccer or its 
                    licensors and protected by law. You may not copy, modify, distribute, or create derivative works 
                    without our prior written permission.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>7) Feedback</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    If you send ideas, suggestions, or other feedback, you grant us a non-exclusive, worldwide, 
                    royalty-free, perpetual license to use, reproduce, and create derivative works from that feedback 
                    without obligation to you.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>8) Third-Party Links</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    The site may contain links to third-party websites we do not control. We are not responsible for 
                    their content, policies, or practices.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>9) Disclaimers</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    The site is provided "as is" and "as available." To the maximum extent permitted by law, we 
                    disclaim all warranties—express, implied, or statutory—including merchantability, fitness for a 
                    particular purpose, and non-infringement.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>10) Limitation of Liability</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    To the maximum extent permitted by law, Rite Soccer and its affiliates will not be liable for any 
                    indirect, incidental, special, consequential, or punitive damages, or any loss of profits or 
                    revenues, arising from or related to your use of (or inability to use) the site, even if we have been 
                    advised of the possibility of such damages.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>11) Indemnity</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    You agree to indemnify and hold Rite Soccer and its affiliates harmless from any claims, 
                    damages, losses, liabilities, and expenses (including reasonable attorneys' fees) arising from your 
                    breach of these Terms or your misuse of the site.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>12) Governing Law & Dispute Resolution</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    These Terms are governed by the laws of <strong>Delaware, USA</strong>, without regard to its conflicts-of-law 
                    rules. Except for claims that may be brought in small-claims court, any dispute will be resolved 
                    by <strong>binding arbitration in Boston, Massachusetts or Wilmington, Delaware</strong>. You waive the 
                    right to participate in class or representative actions to the fullest extent permitted by law.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>13) Changes</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    We may update these Terms from time to time. The "Last updated" date reflects the latest 
                    version. Material changes will be posted on this page.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>14) Contact</h3>
                  <p style={{ marginBottom: "50px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    Email: <a href="mailto:info@ritesoccer.com" style={{ color: "#005214", textDecoration: "none" }}>info@ritesoccer.com</a>
                  </p>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer " id="footer-contact">
          <div className="container">
            <div className="text-center">
              <img
                src="./assets/footer-logo.png"
                alt="Rite Soccer Logo"
                className="mb-3 footer-logo"
              />

              <h2>Let's connect</h2>

              <p>
                Say hello by email for inquiries, support, partnerships or
                promotion <br></br>
                (
                <a href="mailto:info@ritesoccer.com">info@ritesoccer.com</a>)
              </p>
              <div className="col-12 text-center mb-4">
                <p className="mb-0 address">
                  <img src="./assets/map.png" style={{ width: '14px' }} />35 Payne Street, Quincy MA.
                </p>
              </div>

              {/* Social Icons Row */}
              <div className="row justify-content-center g-3 social-icons">
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/x-icon.png" alt="X" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/instagram-icon.png" alt="Instagram" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/tiktok-icon.png" alt="TikTok" />
                  </a>
                </div>
              </div>
            </div>

            <div className="row copy-right">
              <div className="col-6 text-start">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-6 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "flex-end",
                }}
              > 
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

            <div className="copy-right-mob">
              <div className="col-mob text-center">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-12 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

          </div>
        </footer>
      </div>

      <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default TermsConditions;